import { render, staticRenderFns } from "./ConfiguracaoGeralParametrosDashboard.vue?vue&type=template&id=4973dcce&scoped=true"
import script from "./ConfiguracaoGeralParametrosDashboard.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGeralParametrosDashboard.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGeralParametrosDashboard.vue?vue&type=style&index=0&id=4973dcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973dcce",
  null
  
)

export default component.exports